import initProductCollapsableFilters from "components/jiffy/aside-filter/aside-filter";

document.addEventListener("DOMContentLoaded", initProductCollapsableFilters);
